import { Grid, Skeleton } from '@mui/material';

const LoadingAdmin = ({numberOfItems = 3, height = 150, xsSize = 12}) => {
  return (
    <Grid container spacing={2}>
      {[...Array(numberOfItems)].map((_, index) => (
        <Grid item xs={xsSize} lg={6} xl={4} key={index}>
          <Skeleton variant="rectangular" height={height} sx={{ borderRadius: 1 }} />
        </Grid>
      ))}
    </Grid>
  );
};

export default LoadingAdmin;
